// extracted by mini-css-extract-plugin
export default {"container":"FixedDiv_container__JBGQW","disabled":"FixedDiv_disabled__Pkeu7"};